module.exports = "../images/fishing-lodge-ontario-fishfry.jpg?v=fd3f007";